export function useGlobSetting() {
    // 请求域名
    // const baseUrl: string = 'http://192.168.0.66:9797';
    const baseUrl: string = 'https://api.v1.jxcbyun.com';

    // url前缀
    const urlPrefix: string = '/api';

    // token名称
    const tokenKey: string = 'X-Token';

    // token前缀
    const tokenPrefix: string = '';

    // 微信H5网页 Appid
    const wx_appid = 'wx2bc51d5c97e9293a';

    // 支付宝H5网页 Appid
    const ali_appid = '2021006145670895';

    return {baseUrl, urlPrefix, tokenKey, tokenPrefix, wx_appid, ali_appid};
}
